import { Profile } from '@witkac/kartamiejska-shared';
import {
  ProfileResource,
  profileResource
} from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł profili
 *
 * @export
 * @class ProfileModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class ProfileModule extends EntityModule<Profile, ProfileResource> {}

export default new ProfileModule(profileResource);
